<template>
  <footer>
    <div class="footer-container">
      <div class="copy-right">
        <img src="../assets/images/ceati-logo.svg" alt="联盟">
        <span>©版权所有2020 网络安全威胁情报生态联盟</span>
        <span style="text-align: left;">
            京ICP备16020626号
        </span>
      </div>

      <div style="display: flex;justify-content: space-between;">
        <div class="site-nav">
          <h4>站内导航</h4>
          <ul>
            <li><router-link :to="{ name: 'introuduce'}">联盟简介</router-link></li>
            <li><router-link :to="{ name: 'regulations'}">联盟章程</router-link></li>
            <li><router-link :to="{ name: 'capability'}">联盟能力</router-link></li>
            <li><router-link :to="{ name: 'members'}">联盟成员</router-link></li>
            <li><router-link :to="{ name: 'redownload'}">资源下载</router-link></li>
          </ul>
        </div>
        <div class="mail">
          <h4>联系邮箱</h4>
          <ul>
            <li><a href="mailto:support@ceati.org.cn">support@ceati.org.cn</a></li>
          </ul>
        </div>
        <!-- <div class="contact">
          <h4>服务热线</h4>
          <ul>
            <li><a href="####">4009-303-120</a></li>
          </ul>
        </div> -->
      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'NavHeader',
  data () {
    return {
      currentYear: (new Date()).getFullYear()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  footer {
    padding-top: 32px;
    border-top: 1px solid;
    border-color: rgba($color: #cccccc, $alpha: 0.3);
    background: #ffffff;
  }
  .footer-container {
    width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    h4 {
      font-size: 16px;
      color: #666666;
      text-align: left;
    }
    ul {
      margin-top: 14px;
      display: flex;
      height: 140px;
      flex-direction: column;
      flex-wrap: wrap;
      a {
        font-size: 14px;
        color: #666666;
        line-height: 32px;
        margin-right: 18px;
        &:hover {
          color: #0044cc;
        }
      }
    }
    .copy-right {
      img {
        display: block;
      }
      span {
        font-size: 12px;
        color: #999999;
        margin-top: 25px;
        margin-left: 60px;
        display: block;
      }
    }
  }
  .mail{
    margin-left: 90px;
    a{
      margin-right: 0px;
    }
  }
</style>
